import { framedByDefault } from '@utils/frames';

import { ProductPurchaseDetails } from '../../../types/Purchasing';

// framing, a set or quantity? checkout, otherwise straight to Shopify
export const hasPurchaseOptions = (
  details: ProductPurchaseDetails,
): boolean => {
  const belongsToSet = (details.collectionSet?.length ?? 0) > 1;
  const hasFraming =
    details.frames.length > 0 && !framedByDefault(details.framingOffered);

  return belongsToSet || hasFraming || Boolean(details.allowMultipleProducts);
};
